<template>
  <centered-layout>
    <div class="text-center">
      <v-progress-circular color="primary" class="mb-4" indeterminate></v-progress-circular>
      <h1 class="title">Authorization</h1>
    </div>
  </centered-layout>
</template>

<script>
import CenteredLayout from './layouts/CenteredLayout.vue';

import AuthService from '../auth/service';

import {
  parseUrlHost,
} from '../helpers/http';

export default {
  mounted() {
    this.processAuth()
      .catch((error) => {
        this.$toast.error(error.message);

        this.$router.push({ name: 'auth' });
      });
  },
  methods: {
    processAuth() {
      const {
        code,
        redirect_uri: redirect,
      } = this.$route.query;

      return this.processAuthCode(code)
        .then(() => this.processRedirect(redirect));
    },
    processAuthCode(code) {
      if (!code) {
        throw new Error('Code is not specified');
      }

      return AuthService.authorize(code);
    },
    processRedirect(redirect) {
      if (!redirect) {
        this.$router.push({ name: 'main' });

        return;
      }

      const redirectHost = parseUrlHost(redirect);

      if (redirectHost !== window.location.host) {
        this.$router.push({ name: 'main' });

        return;
      }

      window.location.href = redirect;
    },
  },
  components: { CenteredLayout },
};
</script>
